export default __webpack_public_path__ + "static/media/colored-offer-delete-icon.da3e7983.svg";